import { createAction, createReducer } from '@reduxjs/toolkit';

const CLEAR_ENDPOINT = createAction('endpoint/clearEndpoint');
const SET_ENDPOINT = createAction('endpoint/setEndpoinnt');
const TRIGGER_REFRESH = createAction('endpoint/triggerRefresh');
const SET_MODEL = createAction('endpoint/setModel');

export const actions = {
  CLEAR_ENDPOINT,
  SET_ENDPOINT,
  TRIGGER_REFRESH,
  SET_MODEL,
};

function clearEndpoint(prev, _action) {
  return {
    ...prev,
    model: null,
    endpointId: null,
  };
}

function setEndpoint(prev, action) {
  const { payload } = action;
  const { endpointId } = payload;

  return {
    ...prev,
    endpointId,
  };
}

function setModel(prev, action) {
  const { payload } = action;
  const { model } = payload;

  return {
    ...prev,
    model,
  };
}

function triggerRefresh(prev, _action) {
  return { ...prev, refresh: prev.refresh + 1 };
}

const reducer = createReducer(
  {
    refresh: 0,
    endpointId: null,
    model: null,
  },
  {
    [CLEAR_ENDPOINT]: clearEndpoint,
    [SET_ENDPOINT]: setEndpoint,
    [TRIGGER_REFRESH]: triggerRefresh,
    [SET_MODEL]: setModel,
  }
);

export default reducer;
